import React from "react";
import { MaterialDesignIcons } from "../styled";

export const DownloadMIcon: React.FC<{ fontSize?: string }> = ({ fontSize }) => {
  return <MaterialDesignIcons fontSize={fontSize}>download</MaterialDesignIcons>;
};
